module.exports = __webpack_public_path__ + "img/vietnam-logo-icon.d64dd785.png";